import ScrollReveal from "../../../components/feature/ScrollReveal";
import { useContactData } from "../../../lib/useMockData";

export default function NotesSection() {
  const { notesData } = useContactData();
  return (
    <section className="py-16 md:py-24 bg-airdoa-cream">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-2xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-8">
              <p className="section-label mb-3">{notesData.label}</p>
              <h2 className="section-title">{notesData.title}</h2>
            </div>
          </ScrollReveal>

          <ScrollReveal direction="up" delay={150}>
            <div className="bg-white rounded-lg p-6 md:p-8">
              <ul className="flex flex-col gap-3">
                {notesData.items.map((item, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <span className="w-5 h-5 flex items-center justify-center text-airdoa-gold shrink-0 mt-0.5">
                      <i className="ri-information-line" />
                    </span>
                    <p className="text-sm text-airdoa-gray leading-relaxed">{item}</p>
                  </li>
                ))}
              </ul>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}